module.exports = __webpack_public_path__ + "img/47-mensagens-enviadas-lista.6e7cdd95.png";